
import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Problem from './components/Problem';
import System from './components/System';
import WhatItDoes from './components/WhatItDoes';
import Differentiation from './components/Differentiation';
import Results from './components/Results';
import SocialProof from './components/SocialProof';
import CTASection from './components/CTASection';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

export default function Home() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="relative">
      <Navbar scrolled={scrolled} />
      <main>
        <Hero />
        <Problem />
        <System />
        <WhatItDoes />
        <Differentiation />
        <Results />
        <SocialProof />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
